import { HomeView } from '@/views/HomeView';
import { MainLayout } from '@/widgets/layouts/MainLayout';

export const HomePage = () => (
  <MainLayout meta={{ title: 'Home' }}>
    <HomeView />
  </MainLayout>
);
